import {
    FRIEND_DISCOUNT_PERCENT_TODAY,
    POINTS_V4,
    WEEK_ON_PLAN_POINTS,
} from "@/shared/config/pointsRules";
import { SITE_WORKOUT_PAGES_HIDDEN } from "./siteWorkoutPages";

/**
 * Постоянные нового меню кабинета (V5, пока только админам).
 *
 * Числа на плашках — из таблицы баллов v8.2 (shared/config/pointsRules.ts). Для
 * администраторов (а меню V5 видят только они) таблица уже настоящая (POINTS_V82_LIVE) —
 * всё сплошными чипами «за что → сколько»: «+2 000 за неделю по плану», «Доброе дело · +100».
 */

/** «+2 000 тренировки за неделю по плану» — действующая награда за план. */
export const PLAN_WEEK_POINTS = WEEK_ON_PLAN_POINTS;

/** «+100 общественное» за доброе дело (раз в день, 100 в год) — таблица v8.2. */
export const GOOD_DEED_POINTS = POINTS_V4.club.goodDeed;

/** «другу −10 %» — скидка другу по реферальной ссылке (страница «Реферальная программа»). */
export const FRIEND_DISCOUNT_PERCENT = FRIEND_DISCOUNT_PERCENT_TODAY;

/**
 * Пункт «Лига участников» в «Прогресс и лига». Страница /account/league-users
 * (ветка feat/v5-league-ui) влита вместе с меню, поэтому пункт показан.
 */
export const LEAGUE_USERS_IN_MENU = true;

/**
 * «Тренировки» и «Календарь» нового меню — адреса /account/training и
 * /account/calendar, которых до него не было вовсе. Пока рубильник
 * SITE_WORKOUT_PAGES_HIDDEN не в "all", всем, кроме админа (и админу в режиме
 * «смотреть как пользователь»), они отвечают голым «404» без кабинета — ровно
 * как до их появления. Калиток две: невошедшему — RequireAuth (вместо
 * страницы входа), вошедшему не админу — AccountPage (pages/Account/index.tsx),
 * ещё до хранилищ и кабинета. В "all" калиток нет (trainingPagesForAll ниже).
 * Как и роутер, регистр букв и косая черта в конце не важны.
 */
const APP_ONLY_PATH_RE = /^\/[^/]+\/account\/(training|calendar)\/?$/i;
/**
 * Так же — новые адреса телефонного кабинета «как приложение»
 * (features/appShell, предпросмотр): меню профиля, карта встреч во весь
 * экран, «Все встречи», «О группе», «Найти группу», новая группа, модерация. До них эти
 * адреса ловил NOT_FOUND — голое «404» без кабинета; всем, кроме админа, так
 * и остаётся.
 */
const SHELL_ONLY_PATH_RE =
    /^\/[^/]+\/account\/(menu|community\/map|community\/meetings|community\/groups|community\/groups\/new|community\/moderation|community\/group\/[^/]+\/info)\/?$/i;
/**
 * Рубильник SITE_WORKOUT_PAGES_HIDDEN в положении "all": календарь, план и
 * загрузка скрыты у всех, и «Тренировки» (карточка приложения и тестовая
 * тренировка) открыты всем — прежнее меню ведёт туда; /account/calendar —
 * вкладка «Календарь» (та же карточка, владелец 20.10), а у кого её нет —
 * переход туда же.
 */
const trainingPagesForAll = (): boolean => SITE_WORKOUT_PAGES_HIDDEN === "all";
export const isAppOnlyPath = (pathname: string): boolean =>
    (!trainingPagesForAll() && APP_ONLY_PATH_RE.test(pathname || "")) || SHELL_ONLY_PATH_RE.test(pathname || "");

/**
 * Только адреса оболочки (без «Тренировок» и «Календаря» — те у админа есть и
 * на компьютере, в меню V5). Без оболочки — и у админа на компьютере — голое
 * «404», как до них (калитка AccountPage).
 */
export const isShellOnlyPath = (pathname: string): boolean => SHELL_ONLY_PATH_RE.test(pathname || "");

/*
 * Куда ведёт «Установить» — решает умная кнопка магазина
 * (shared/ui/SmartStoreButton, правила — shared/lib/appStores.ts): iPhone —
 * App Store, Android — RuStore в России или Google Play вне её (спросит, где
 * человек), компьютер — окно с обоими магазинами и QR. Прежней installUrl()
 * (телефон — свой магазин, компьютер — /my-revive) больше нет.
 */

/**
 * Адрес страницы кабинета «Общение и встречи» с открытым разделом.
 * Раздел — в адресе (?tab=), чтобы пункт меню и ссылка вели прямо в него.
 */
export type CommunityTab = "meetings" | "chats" | "people";
export const COMMUNITY_TAB_PARAM = "tab";

/**
 * ?view=map — прежняя страница «Общение и встречи» (с картой) и для админа:
 * на неё ведут «Карта встреч», «Все мероприятия» и «•••» новой страницы.
 */
export const OLD_VIEW_PARAM = "view";
export const MAP_VIEW_VALUE = "map";
